import { asBoolean, asNumber, asString, formatCount, resolveUserAvatar, upscaleArtwork } from "./common";

export function createUserModel(user = {}) {
  const avatar = asString(user.avatar_url);
  return {
    id: asNumber(user.id),
    kind: asString(user.kind),
    username: asString(user.username, "Unknown User"),
    avatar_url: avatar,
    first_name: asString(user.first_name),
    last_name: asString(user.last_name),
    full_name: asString(user.full_name),
    city: asString(user.city),
    country_code: asString(user.country_code),
    description: asString(user.description),
    followers_count: asNumber(user.followers_count),
    followings_count: asNumber(user.followings_count),
    track_count: asNumber(user.track_count),
    playlist_count: asNumber(user.playlist_count),
    verified: asBoolean(user.verified),
    urn: asString(user.urn),
    hdAvatarURL: upscaleArtwork(avatar, "t500x500"),
  };
}

export function createUserCardModel(user) {
  const normalized = createUserModel(user);
  return {
    id: `user-${normalized.id || normalized.username || "unknown"}`,
    title: normalized.username,
    artist: `${formatCount(normalized.track_count)} tracks`,
    duration: `${formatCount(normalized.followers_count)} followers`,
    image: resolveUserAvatar(normalized),
    model: normalized,
  };
}
